let _Symbol$iterator;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as $rdf from '@rdf-esm/data-model';
import { rdf, hydra } from '@tpluscode/rdf-ns-builders';
import TermMap from '@rdf-esm/term-map';
_Symbol$iterator = Symbol.iterator;
export default class {
  constructor(graph, factory, rootResource) {
    _defineProperty(this, "__graph", void 0);

    _defineProperty(this, "__factory", void 0);

    _defineProperty(this, "rootNode", void 0);

    _defineProperty(this, "__uniqueResources", void 0);

    this.__graph = graph;
    this.__factory = factory;
    this.rootNode = graph.node(rootResource);

    this.__uniqueResources = (() => {
      let map;
      return () => {
        if (!map) {
          map = this.__graph.in().toArray().reduce((uniq, pointer) => {
            if (!uniq.has(pointer.term)) {
              return uniq.set(pointer.term, this._createEntity(pointer));
            }

            return uniq;
          }, new TermMap());
        }

        return map;
      };
    })();
  }

  get(uri, {
    allObjects = false
  } = {}) {
    const pointer = this.__graph.namedNode(decodeURI(uri));

    const isSubject = pointer.out().terms.length > 0;
    const isObjectAndAllowedToReturn = allObjects && pointer.in().terms.length;

    if (!isSubject && !isObjectAndAllowedToReturn) {
      return undefined;
    }

    return this.__factory.createEntity(pointer);
  }

  get root() {
    const collectionNode = this.rootNode.in(hydra.view);

    if (collectionNode.term) {
      return this.__factory.createEntity(collectionNode);
    }

    return this.__factory.createEntity(this.rootNode);
  }

  get length() {
    return this.__uniqueResources().size;
  }

  ofType(classId) {
    const type = typeof classId === 'string' ? $rdf.namedNode(classId) : classId;
    return this.__graph.has(rdf.type, type).map(r => this._createEntity(r));
  }

  [_Symbol$iterator]() {
    return this.__uniqueResources().values();
  }

  _createEntity(node) {
    return this.__factory.createEntity(node);
  }

}